export default {
    props: {
        size: {
            type: Number,
            default: 50,
        },
    },
};
